import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    MenuItem,
    Button,
    Paper,
    Divider,
    Grid,
    InputAdornment,
} from "@mui/material";
import {
    getFirestore,
    collection,
    getDocs,
    addDoc,
    serverTimestamp,
} from "firebase/firestore";
import Fiananceheader from "./Fiananceheader";
import { toast } from 'react-toastify';

const db = getFirestore();

function Loangiven() {
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [loanAmount, setLoanAmount] = useState("");
    const [amountCutting, setAmountCutting] = useState("");
    const [emiStartDate, setEmiStartDate] = useState("");
    const [loading, setLoading] = useState(false);


    // Calculate actual amount given to the customer
    const actualAmountGiven = Number(loanAmount) - Number(amountCutting);

    useEffect(() => {
        const fetchCustomers = async () => {
            const snap = await getDocs(collection(db, "fianancecustomers"));
            const list = snap.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setCustomers(list);
        };
        fetchCustomers();
    }, []);

    const handleSubmit = async () => {
        if (!selectedCustomer || !loanAmount || !amountCutting || !emiStartDate) {
            toast.error("Please fill all fields!");
            return;
        }
        setLoading(true);

        try {
            // Step 1: Save loan
            const loanRef = await addDoc(collection(db, "loans"), {
                custid: selectedCustomer,
                loanamount: Number(loanAmount),
                amountcutting: Number(amountCutting),
                actualamount: actualAmountGiven,
                loandate: emiStartDate,
                status: "pending",
            });

            // Step 2: Create 100 EMIs based on the loanAmount, not actualAmountGiven
            // const emiPerDay = Number(loanAmount) / 100;
            // const startDate = new Date(emiStartDate);

            // for (let i = 0; i < 100; i++) {
            //     const emiDate = new Date(startDate);
            //     emiDate.setDate(startDate.getDate() + i);

            //     await addDoc(collection(db, "loanemis"), {
            //         custid: selectedCustomer,
            //         loanid: loanRef.id,
            //         amountperday: emiPerDay,
            //         date: emiDate,
            //         status: "pending",
            //         paymentDate: "",
            //         paymentType: "",
            //         paymentNote: "",
            //         paidAt: "",
            //     });
            // }

            toast.success("Loan created successfully✅");

            // Reset form
            setSelectedCustomer("");
            setLoanAmount("");
            setAmountCutting("");
            setEmiStartDate("");
        } catch (err) {
            console.error("Error adding loan:", err);
            toast.error("Something went wrong!");
        }

        setLoading(false);
    };

    return (
        <Box p={3} >
            <Fiananceheader />

            <Paper
                sx={{
                    p: 4,
                    borderRadius: "5px",
                }}
            >
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontWeight: 700,
                        textAlign: "center",
                        color: "#1976d2",
                        mb: 3,
                    }}
                >
                    💰 कर्ज दिलेली माहिती 
                </Typography>

                <Divider sx={{ mb: 3 }} />

                <Grid container className="row">
                    {/* Select Customer */}
                    <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                        <TextField
                            select
                            size="small"
                            fullWidth
                            label="Select कर्जदार "
                            value={selectedCustomer}
                            onChange={(e) => setSelectedCustomer(e.target.value)}
                            variant="outlined"
                        >
                            {customers.map((cust) => (
                                <MenuItem key={cust.id} value={cust.id}>
                                    {cust.name || "Unnamed"} ({cust.mobile || "No mobile"})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    {/* Loan Amount */}
                    <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="कर्जाची रक्कम "
                            type="number"
                            value={loanAmount}
                            onChange={(e) => setLoanAmount(e.target.value)}
                            variant="outlined"
                        />
                    </Grid>

                    {/* Amount Cutting */}
                    <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="कटिंग रक्कम (Interest/Fees)"
                            type="number"
                            value={amountCutting}
                            onChange={(e) => setAmountCutting(e.target.value)}
                            variant="outlined"
                        />
                    </Grid>

                    {/* Actual Amount Given - READ ONLY */}
                    <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="हातात दिलेली रक्कम "
                            value={actualAmountGiven}
                            variant="outlined"
                            InputProps={{
                                readOnly: true,
                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                            }}
                        />
                    </Grid>

                    {/* EMI Start Date */}
                    <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="हप्ता या तारखेपासून चालू "
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={emiStartDate}
                            onChange={(e) => setEmiStartDate(e.target.value)}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>

                {/* Submit Button */}
                <Box mt={3}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        sx={{
                            py: 1,
                            fontWeight: 600,
                            borderRadius: "2px",
                            background: "linear-gradient(90deg, #1976d2, #2196f3)",
                            "&:hover": {
                                background: "linear-gradient(90deg, #1565c0, #1976d2)",
                            },
                        }}
                    >
                        {loading ? "Processing..." : "Give Loan"}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}

export default Loangiven;